import styles from "./styles.module.scss";
import React, { useEffect, useState, useRef, useMemo } from "react"
import { Button, Modal, Toast } from "antd-mobile";
import Library from "../../../../library";
import Service from "../service"
import { RulesModal } from "../../../../components";

const { JsBridge, Util } = Library;

/**
 * @description 国家地理藏品抽奖页
 * @update 1.动画滚动仅点亮外围8格，全程不点亮中间按钮
 * @update 2.只有index=9隐藏奖品动画跑完后，中间按钮高亮；1~8号奖品停对应外围格子
 */
export default () => {
  const { activityCode } = Library.Util.url.paramsToObj()
  const [isSwap, setIsSwap] = useState(false);
  const [isBegin, setIsBegin] = useState(false); // 是否正在滚动动画
  const [thisStep, setThisStep] = useState(0); // 当前总步数（业务序号1~8循环）
  const [endSteps, setEndSteps] = useState(0); // 动画停止终点步数
  const [gift, setGift] = useState(null); // 中奖奖品数据
  const [hasClick, setHasClick] = useState(false); // 防重复点击
  const [playTimes, setPlayTimes] = useState(0); // 剩余抽奖次数
  const [giftList, setGiftList] = useState([]);
  const [pageData, setPageData] = useState({})
  // 仅抽到index=9隐藏奖品、动画结束时为true，控制中间按钮高亮
  const [stopAtCenter, setStopAtCenter] = useState(false);

  const timerRef = useRef(null);
  const runnerRef = useRef(null);

  const getGiftListInfo = async () => {
    const result = await Service.fetchGifts(true, { activityCode })
    if (result?.data) {
      setGiftList(result.data);
    }
  }
  const getInitData = async () => {
    const result = await Service.getInitData(true, { activityCode })
    if (result?.data) {
      setPageData(result.data);
      setPlayTimes(result.data?.remainTimes || 0);
    }
  }

  useEffect(() => {
    getInitData()
    getGiftListInfo()
    timerRef.current = setInterval(() => {
      setIsSwap(prev => !prev);
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [])

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = pageData;
    if (!systemTime || !startTime || !endTime) {
      msg = "接口异常";
      return msg;
    }
    const currentT = new Date(systemTime.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime.replace(/-/g, "/")).getTime();
    if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }
    return msg;
  }, [pageData])

  // 生成数字数组工具
  const genArr = (len) => Array.from({ length: len }, (_, i) => i + 1)

  // 渲染四周圆点
  const renderCircle = (num, prefix, reverse = false) => {
    const isOdd = num % 2 !== 0;
    let bgColor;
    if (!reverse) {
      bgColor = !isSwap ? (isOdd ? '#FFE7A8' : '#EA6824') : (isOdd ? '#EA6824' : '#FFE7A8');
    } else {
      bgColor = !isSwap ? (isOdd ? '#EA6824' : '#FFE7A8') : (isOdd ? '#FFE7A8' : '#EA6824');
    }
    return (
      <div
        key={`${prefix}-${num}`}
        className={`${styles[prefix]} ${styles[`${prefix}${num}`]}`}
        style={{ backgroundColor: bgColor }}
      />
    )
  }

  const closeDialog = () => {
    setStopAtCenter(false)
    Modal.clear()
  };

  // 编辑实物收货地址
  const editAddress = (reward) => {
    const param = Util.url.objectToQueryParams({
      idf: 'lottery',
      activityCode,
      id: reward.id,
      name: reward.value,
      imgUrl: reward.imgUrl
    })
    JsBridge.push('CustomWeb', { uri: `${window.location.origin}/front/guapp/activityOrder?${param}` });
  }

  // 跳转我的藏品
  const lookMyCollection = () => {
    JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_NFT_LINK}/myCollection` });
  }

  // 弹窗左侧按钮
  const leftBtnClick = (reward) => {
    const type = reward.type;
    closeDialog();
    setTimeout(() => {
      if (type === 8) lookMyCollection();
      if (type === 1) JsBridge.push('Web', { uri: `${process.env.REACT_APP_GKT_LINK}/taro/subPages/user/coupon/myCoupon/index` });
    }, 500);
  }

  // 弹窗右侧按钮
  const rightBtnClick = (reward) => {
    const type = reward.type;
    closeDialog();
    setTimeout(() => {
      if (type === 3) editAddress(reward);
    }, 500);
  }

  // 中奖弹窗
  const showRewardModal = (prize) => {
    let title = '恭喜中奖！';
    let firstTitle = '';
    let secondTitle = '';
    let leftBtnText = '取消';
    let rightBtnText = '继续抽奖';

    switch (prize.type) {
      case 0: // 积分
        firstTitle = prize.value;
        secondTitle = `恭喜您抽中${prize.value}\n请在【积分-我的积分】查看`;
        leftBtnText = '我知道了';
        break;
      case 3: // 实物
        firstTitle = prize.value;
        secondTitle = `恭喜您抽中${prize.value}\n请填写收货地址，我们会第一时间发放奖品`;
        leftBtnText = '继续抽奖';
        rightBtnText = '填写地址';
        break;
      case 8: // 数字藏品
        firstTitle = prize.value;
        secondTitle = `恭喜您抽中${prize.value}\n请在【我的-我的藏品】查看`;
        leftBtnText = '查看藏品';
        break;
      case 9: // 未中奖
        title = '谢谢参与！';
        firstTitle = '很遗憾未中奖';
        secondTitle = '继续抽奖，获奖概率更高哦';
        break;
      default:
        firstTitle = prize.value;
        secondTitle = `恭喜您抽中${prize.value}`;
        leftBtnText = '我知道了';
    }

    Modal.show({
      content: (
        <div className={styles.dialog_container}>
          <div className={styles.dialog_title}>{title}</div>
          <div className={styles.first_title}>{firstTitle}</div>
          {prize.imgUrl && <img src={prize.imgUrl} alt="奖品图" />}
          <div className={styles.second_title}>{secondTitle}</div>
          <div className={styles.btn_container}>
            <div className={styles.left_btn} onClick={() => leftBtnClick(prize)}>{leftBtnText}</div>
            <div className={styles.right_btn} onClick={() => rightBtnClick(prize)}>{rightBtnText}</div>
          </div>
        </div>
      )
    })
  }

  /**
   * 九宫格布局映射 gridIndex → 业务奖品序号(1-8)
   * gridIndex: 0 1 2 3 4 5 6 7 8
   * prizeNo:   1 2 3 4 - 5 6 7 8
   */
  const giftIndexMap = [1, 2, 3, 4, null, 5, 6, 7, 8];

  // 动画递归滚动
  const startAnimation = (interval = 500, targetPrizeNo, isOuterReward, result) => {
    setEndSteps(prevEnd => {
      setThisStep(prevStep => {
        const newEnd = prevEnd - 1;
        const newStep = prevStep + 1;
        // 动画结束
        if (newEnd <= 0) {
          clearTimeout(runnerRef.current);
          // 仅抽到index=9隐藏奖品，标记中间高亮
          setStopAtCenter(isOuterReward);
          setTimeout(() => {
            showRewardModal(result)
            setIsBegin(false);
          }, 300);
          return newStep;
        }
        // 变速逻辑：先快后慢
        const nextInterval = newEnd < 5 ? Math.min(1000, interval + 200) : Math.max(50, interval - 200);
        runnerRef.current = setTimeout(() => startAnimation(nextInterval, targetPrizeNo, isOuterReward, result), nextInterval);
        return newStep;
      })
      return prevEnd - 1;
    })
  }

  // 抽奖点击事件
  const getAward = async () => {
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if(playTimes <= 0) {
      Toast.show('您的抽奖次数不足')
      return
    }
    if (isBegin || hasClick || playTimes <= 0) return;
    setStopAtCenter(false); // 每次抽奖重置中间高亮标记

    const res = await Service.lotteryGift({activityCode, reduceTimes: 1})

    if (res.status > 0) {
      setHasClick(true)
      const result = res.data
      // 修复核心判断：只有index=9才是隐藏奖品，停中间按钮
      const isOuterReward = result.index === 9;
      let targetPrizeNo;
      if (isOuterReward) {
        // 隐藏奖品：动画循环结束停中间，动画终点固定第8号奖品
        targetPrizeNo = 8;
      } else {
        // 直接使用后端返回index作为业务序号1~8，直观对应第几个奖品
        targetPrizeNo = result.index;
      }
      // 计算总滚动步数
      const currentLoopPrizeNo = ((thisStep - 1) % 8) + 1; // 当前循环到的业务序号1~8
      const diff = Math.abs(8 - currentLoopPrizeNo + targetPrizeNo);
      const totalEndSteps = 24 + diff;

      setGift(result);
      setPlayTimes(pre => pre - 1);
      setIsBegin(true);
      setEndSteps(totalEndSteps);
      setTimeout(() => startAnimation(500, targetPrizeNo, isOuterReward, result), 200);
    }
    setHasClick(false);
  }

  // 只取前8个奖品展示在外围九宫格
  const showGiftList = giftList.slice(0, 8);

  // 渲染单个九宫格格子
  const giftRender = (_, gridIndex) => {
    const targetPrizeNo = giftIndexMap[gridIndex];
    // 中间抽奖按钮格子
    if (gridIndex === 4) {
      // 仅抽到隐藏奖品动画结束才高亮中间
      const cls = stopAtCenter ? `${styles.handleBtn} ${styles.outGiftActive}` : styles.handleBtn;
      return (
        <div key={gridIndex} className={cls} onClick={getAward}>
          开始<br/>抽奖
        </div>
      )
    }
    // 获取当前动画循环到的业务序号 1~8
    const currentLoopPrizeNo = ((thisStep - 1) % 8) + 1;
    // 外围奖品格子，业务序号匹配则高亮
    const isActive = targetPrizeNo !== null && currentLoopPrizeNo === targetPrizeNo;
    // 业务序号转数组下标取奖品
    const prizeItem = showGiftList[targetPrizeNo - 1];

    return (
      <div
        key={gridIndex}
        className={!stopAtCenter && isActive ? `${styles.giftItem} ${styles.giftActive}` : styles.giftItem}
      >
        {prizeItem?.imgUrl && (
          <img className={styles.giftImg} src={prizeItem.imgUrl} alt="奖品图" />
        )}
        <div className={styles.giftName}>{prizeItem?.goodsName || ''}</div>
      </div>
    )
  }

  // 打开规则弹窗
  const onRuleClick = () => {
    RulesModal.open({
      btnStyle: {background: 'linear-gradient(90deg, rgb(255, 199, 171) 0%, rgb(250 181 89) 28%, rgb(255 162 56) 75%, rgb(255, 134, 52) 100%)'},
      activityCode,
      codeType: 'activityRule',
      code: activityCode,
      title: '抽奖规则'
    });
  }

  const toMyGifts = () => {
    JsBridge.push('CustomWeb', {uri: `${ window.location.origin}/front/activities/geographyLottery/giftList?activityCode=${activityCode}`})
  }

  return (
    <div className={styles.mainPage}>
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={styles.titleText}>抽奖</div>
        </div>
        <div className={styles.subTitle}>
          普通款（马FuFu），可获得<span className={styles.redText}>1次抽奖机会</span><br/>
          稀有款（钟楼、羊肉泡馍、三秦、大雁塔），可获得<span className={styles.redText}>2次抽奖机会</span>
        </div>
        <div className={styles.ruleBtn} onClick={onRuleClick}>抽奖规则</div>
        <div className={styles.box}>
          {/* 四周闪烁圆点 */}
          {genArr(8).map(item => renderCircle(item, 'topCircle'))}
          {genArr(8).map(item => renderCircle(item, 'bottomCircle'))}
          {genArr(7).map(item => renderCircle(item, 'leftCircle', true))}
          {genArr(7).map(item => renderCircle(item, 'rightCircle'))}

          {/* 9宫奖品容器 */}
          <div className={styles.giftBox}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((_, gridIndex) => giftRender(null, gridIndex))}
            {/* 动画遮罩禁止点击 */}
            {isBegin && <div className={styles.drawMask} />}
          </div>
        </div>
        <Button shape="rounded" className={styles.myGiftBtn} onClick={toMyGifts}>我的奖品</Button>
        <div className={styles.numText}>我的抽奖次数：<span className={styles.redText}>{playTimes || 0}</span></div>
      </div>
      <div className={styles.footer_logo}>
        <img src={require('images/newYear/bottom-logo.png')} alt="" />
      </div>
    </div>
  )
}